import { c as _c } from "react/compiler-runtime";
import { AgeSuitabilityPage } from "@catchy/ui";
import { getRegionConfig } from "../lib/regions/config.mjs";
const region = getRegionConfig("wellington");
export default function AgeSuitability() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AgeSuitabilityPage origin={region.allowedOrigin} transportDescription="buses, trains, and ferries" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}